exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-5-wrapper[data-v-fcfb3a52]{width:235px;padding-bottom:10px}.listing-img[data-v-fcfb3a52]{width:20px;height:20px}", ""]);

// exports
